<template>
	<DjBox class="dj-box-tasks pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ title }}</h3>
		<div class="flex items-start" v-for="(task, index) in data" :key="index">
			<span class="block ml-2 mr-5 mt-[6px] min-w-[12px] w-3 min-h-[12px] h-3 rounded-full bg-dj-blue"></span>
			<span :class="[index != data.length - 1 ? 'mb-4' : '']">{{ task }}</span>
		</div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "DjBoxTasks",
	props: {
		title: {
			type: String,
			default: "title",
		},
		data: {
			type: Array,
			required: true,
		},
		locale: {
			type: String,
			default: "hu",
		},
	},
});
</script>
